import * as t from './actionTypes';
import * as constants from './constants';
import common from '../../common';


export function loadWorkflowLogbook(workflowInstanceId) {
    return async (dispatch, getState) => {
        if (null != workflowInstanceId) {

            const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/workflow/logbook/${workflowInstanceId}`);
            dispatch({
                type: t.LOAD_LOGBOOK,
                payload: resp.data
            })
        } else {
            dispatch({
                type: t.LOAD_LOGBOOK,
                payload: []
            })
        }
    };
}






